// Shared mapping between backend document processing statuses and the
// human-readable labels/colors used across the Uploader and Document
// Manager pages, plus the global upload indicator in the header.

export const STATUS_LABELS = {
    pending: 'Queued for processing...',
    saving: 'Saving Document...',
    embedding: 'Embedding...',
    ingested: 'Done',
    failed: 'Failed',
};

// Statuses that mean the document is still being processed server-side
// (SQL + MinIO + vector store) and hasn't reached a terminal state yet.
export const NON_TERMINAL_STATUSES = ['pending', 'saving', 'embedding'];

export function isNonTerminalStatus(status) {
    return NON_TERMINAL_STATUSES.includes(status);
}

export function getStatusLabel(status) {
    return STATUS_LABELS[status] || status;
}
